<template>
    <div>
        <div class="row mb-2">
            <div class="col-12">
                <div class="shadow-sm input-group input-group-lg">
                    <input 
                        type="text" 
                        class="form-control" placeholder="Carian..."
                        :class="{'border-right-0': keyword == ''}"
                        v-model="keyword"
                    >
                    <div class="input-group-append" v-if="keyword != ''">
                        <button class="btn btn-outline-primary" type="button" v-on:click="keyword = ''">
                            <i class="fas fa-times"></i>
                        </button>
                    </div>
                    <div class="input-group-append" v-else>
                        <span class="input-group-text bg-white text-light-grey">
                            <i class="fas fa-search"></i>
                        </span>
                    </div>
                    
                </div>
            </div>
        </div>
        <div class="table-responsive m-0 bg-white">
            <table id="member-datatable" class="table table-bordered table-hover" style="width: 100%;">
                <thead>
                    <tr>
                        <th class="text-center">Bil.</th>
                        <th>No. KP/ID</th>
                        <th>Nama</th>
                        <th>No. Keahlian</th>
                        <th>No. Telefon</th>
                        <th>Tindakan</th>
                        <th>ID Ahli</th>
                    </tr>
                </thead>
                <tbody></tbody>

            </table>
        </div>
    </div>
</template>

<script>

var vm = null;
var table = null;

var columns = [
    {
        data: "id", 
        defaultContent: '',
        visible : true,
    },
    {
        data    : "ic_no",
        defaultContent: '',
        orderable       : true,
    },
    {
        data    : "name",
        defaultContent: '',
        orderable       : true,
    },
    {
        data    : "membership_id",
        defaultContent: '',
        orderable       : true,
    },
    {
        data    : "phone_no",
        defaultContent: '',
        orderable       : true,
    },
    {
        data            : "action",
        defaultContent  : '',
        orderable       : false,
        searchable      : false,
        visible         : true,
        width           : '15%',
        className       : 'align-middle text-center',
        // The `data` parameter refers to the data for the cell (defined by the
        // `data` option, which defaults to the column being worked with, in
        // this case `data: 0`.
        "render": function (data, type, row) {

            var checked = '';
            if (vm.list.findIndex(e => e.uuid === row.uuid) >= 0) {
                checked = 'checked';
            }

            var html = '<input type="checkbox" value="' + row.uuid + '" ' + checked + '>';
            return html;
        }
    },
    {
        data    : "member_id",
        defaultContent: '',
        orderable       : true,
        visible         : false
    }
];

export default {

    props: [
        'payee',
        'payeeUuid',
        'token', 
        'api',// deprected
        'mainList'// camelcase here, html attribute kebab-case main-list
    ],

    data() {
        return {
            'keyword'           : '',
            'list'              : this.mainList, // hold list of selected item
            'data_columns'      : []
        }
    },

    mounted() {

        vm = this;
        
        this.$nextTick(() => {

            table = $(this.$el).find('table').DataTable({
                responsive: true,
                language: {
                    "info"          : "Rekod _START_ hingga _END_ dari _TOTAL_ rekod",
                    "emptyTable"    : "Tiada rekod",
                    "infoEmpty"     : "0 Rekod",
                    "infoFiltered"  : "(carian dari _MAX_ rekod)",
                    "zeroRecords"   : "Tiada Rekod",
                    "lengthMenu"    : "Papar _MENU_",
                    "paginate"      : {
                        "previous"  : "Sebelum",
                        "next"      : "Seterusnya"
                    }
                },
                dom: '<"row"<"col-12"t>><"py-2"p>',
                order: [[1, "desc"]],
                "pageLength": 10,
                serverSide: true,
                //ordering: false,
                bSortCellsTop: true,
                ajax: {
                    url     : vm.api,
                    type    : 'post',
                    "data": function (d) {
                        d['_token']  = vm.token;
                        d['keyword'] = vm.keyword;
                        d['payee'] = vm.payee;
                        d['payee_uuid'] = vm.payeeUuid;
                    }
                },
                "processing": true,
                rowId: 'id',
                columns: columns,
                //autoWidth: true,
                "columnDefs": [
                ],
                "drawCallback": function(settings) {

                    $('#member-datatable tbody > tr').on('click', 'input[type="checkbox"]', function () {
                        let tr = $(this).parent().parent();
                        let data = table.row(tr).data();
                        //alert( 'You clicked on '+data[0]+'\'s row' );
                        
                        //console.log(data);

                        vm.onActionClick(data, $(this).is(":checked"));
                    });                    
                }
            });

        });
    },

    watch: {
        keyword: function(value) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.reload();
            }, 1000);
        },
    },
    methods: {

        onActionClick(data, is_checked) {

            if (is_checked) {// add into list
                this.list.push(data);
            }
            else {// fix wrong reference, no main_uuid exist
                this.list.splice(this.list.findIndex(e => e.uuid === data.uuid), 1);
            }

            this.$emit('member-datatable-action-click', this.list);
        },
        reload() {
            var table = $(this.$el)
                .find("#member-datatable")
                .DataTable();
            table.ajax.reload(null,false);
            table.draw();
        },
    }
}
</script>